module.exports = __webpack_public_path__ + "img/chr_ts_21_penlight.8ef345b7.png";